export default __webpack_public_path__ + "static/media/partners_background.08d833f9.png";